import { Text } from "@mantine/core";
import { TruckDelivery } from "tabler-icons-react";
import Countdown from './Countdown'

function ShippingSpeed(props) {

    const isExpressShipping = (shipSpeed) => {}

    const shippingSpeedMapping = {
        "1" : {
            label: "Next-Day Delivery",
            color: "#fe653d",
            isExpressShipping: true
        },
        "2" : {
            label: "2-Day Delivery",
            color: "#156aff",
            isExpressShipping: true
        },
        "3" : {
            label: "3-Day Delivery",
            color: "#156aff",
            isExpressShipping: true
        },
        "4" : {
            label: "Express Shipping",
            color: "#156aff",
            isExpressShipping: true
        },
        "5" : {
            label: "Express Shipping",
            color: "#156aff",
            isExpressShipping: true
        },
        "6" : {
            label: "Express Shipping",
            color: "#156aff",
            isExpressShipping: true
        },
        "7" : {
            label: "Express Shipping",
            color: "#156aff",
            isExpressShipping: true
        },
        "15" : {
            label: "Shipping",
            color: "#156aff",
            isExpressShipping: false
        },
    }
    
    return (
    <Text size={13}><TruckDelivery className="icon-tabler icon-tabler-truck-delivery" stroke={'#156aff'} size={15} style={{verticalAlign: "text-bottom", paddingRight: "5"}} ></TruckDelivery><span style={{color: "#156aff", fontWeight: "500"}}>Free {shippingSpeedMapping[props.shippingSpeed].label}!</span>{props.isOutsideUSA || !shippingSpeedMapping[props.shippingSpeed].isExpressShipping ? null : <Countdown secondsToCutoff={props.secondsToCutoff} deliveryDate={props.deliveryDate}></Countdown>}</Text>
    )
  
}

export default ShippingSpeed;
